<app-breadcrumb [master]="'OCK'" [parentName]="'Raporty'" [name]="'Polisy'"></app-breadcrumb>
<div class="ock-policy-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ock-policy-list-filters">
    <mat-form-field class="ock-policy-list-filter">
      <mat-label>Nazwa skrócona</mat-label>
      <input matInput placeholder="Nazwa skrócona" name="shortName" [(ngModel)]="initialFilters.shortName">
    </mat-form-field>

    <mat-form-field class="ock-policy-list-filter">
      <mat-label>NIP</mat-label>
      <input matInput placeholder="NIP" name="nip" [(ngModel)]="initialFilters.nip">
    </mat-form-field>

    <mat-form-field class="ock-policy-list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="Użytkownik" name="user" [(ngModel)]="initialFilters.user">
    </mat-form-field>

    <app-datepicker
      class="ock-policy-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.startConclusionAt" name="startConclusionAt"
    ></app-datepicker>

    <app-datepicker
      class="ock-policy-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.endConclusionAt" name="endConclusionAt"
    ></app-datepicker>
  </form>

  <div class="ock-policy-list-buttons">
    <button *ngIf="(userPermissions | async).ock.create" [disabled]="!(userPermissions | async)?.ock.create" mat-raised-button class="report-button" (click)="downloadReport()">
      <mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef> Numer polisy</th>
      <td mat-cell *matCellDef="let element">
        {{element.number}}
      </td>
    </ng-container>

    <ng-container matColumnDef="conclusion">
      <th mat-header-cell *matHeaderCellDef> Data zawarcia </th>
      <td mat-cell *matCellDef="let element">
        {{dataToString(element.conclusion)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="data">
      <th mat-header-cell *matHeaderCellDef> Okres ochrony </th>
      <td mat-cell *matCellDef="let element">
        {{dataToString(element.startAt)}} - {{dataToString(element.endAt)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        {{statusString(element.status)  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="car">
      <th mat-header-cell *matHeaderCellDef> Typ pojazdu </th>
      <td mat-cell *matCellDef="let element">
        {{element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sum">
      <th mat-header-cell *matHeaderCellDef> Składka </th>
      <td mat-cell *matCellDef="let element">
        {{ element.sumPolicy  }} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.firstName }} {{element.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{ element.shortName  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element">
        {{element.nip}}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>


